var PropertyTypeCategory;
(function (PropertyTypeCategory) {
  PropertyTypeCategory["HOUSE"] = "HOUSE";
  PropertyTypeCategory["UNIT"] = "UNIT";
  PropertyTypeCategory["TOWNHOUSE"] = "TOWNHOUSE";
  PropertyTypeCategory["OTHER"] = "OTHER";
})(PropertyTypeCategory || (PropertyTypeCategory = {}));
export default PropertyTypeCategory;